import type { ToolMeta } from './registry';

export const getSupplierDetailsMeta = {
  description:
    "Returns one supplier's full listing by id — capacity, prices, accommodation, timings, licence, catering terms and facilities.",
  examples: [
    'Tell us more about Winters Barns',
    'Does this venue allow candles?',
    'What does the hire fee include at The Thatched Barn?',
  ],
  value: 'the full listing facts for one venue or supplier',
  grounding: 'venue',
} as const satisfies ToolMeta;
